export enum MonthsToString {
  'oneMonth' = 1,
  'threeMonth' = 3,
  'oneYear' = 12,
}
